import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

const getButtonColor = (theme, { disabled, active, isKiteUser, error }) => {
  let buttonColor;
  if (disabled) {
    buttonColor = 'rgba(0, 0, 0, 0.38)';
  } else if (!active) {
    buttonColor = theme.palette.grey1;
  } else {
    buttonColor = pickIf(
      isKiteUser,
      theme.palette.primary1,
      theme.palette.primary2,
    );
  }
  if (error) {
    buttonColor = '#C5203F';
  }
  return buttonColor;
};

const getInputColor = (theme, { active, isKiteUser, error }) => {
  let inputColor;
  if (!active) {
    inputColor = theme.palette.grey1;
  } else {
    inputColor = pickIf(
      isKiteUser,
      theme.palette.primary1,
      theme.palette.primary2,
    );
  }
  if (error) {
    inputColor = '#C5203F';
  }
  return inputColor;
};

export const useStyles = makeStyles()(
  (theme, { isKiteUser, error, active, disabled } = {}) => {
    const buttonColor = getButtonColor(theme, {
      disabled,
      active,
      isKiteUser,
      error,
    });
    const inputColor = getInputColor(theme, { active, isKiteUser, error });

    return {
      relativeBox: { position: 'relative' },
      button: {
        alignItems: 'center',
        border: `1px solid ${buttonColor}`,
        borderRadius: 25,
        color: buttonColor,
        padding: '7px 12px',
        pointerEvents: pickIf(disabled, 'none', 'initial'),
        width: 130,
        [theme.breakpoints.down('lg')]: {
          fontSize: 14,
          padding: '7px 5px',
          width: 96,
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            fontSize: 14,
            padding: '7px 5px',
            width: 96,
          }),
        },
      },
      icon: {
        cursor: pickIf(!active, 'initial', 'pointer'),
        fontSize: 20,
        '&:hover': {
          backgroundColor: pickIf(!active, 'none', theme.palette.lightGrey),
        },
        [theme.breakpoints.down('lg')]: {
          '&:hover': {
            backgroundColor: 'inherit',
          },
        },
        [theme.breakpoints.downLandscape('lg')]: {
          ...(theme.isMobileDevice && {
            '&:hover': {
              backgroundColor: 'inherit',
            },
          }),
        },
      },
      input: {
        display: 'flex',
        '& .MuiOutlinedInput-root': {
          padding: '0 !important',
        },
        '& fieldset': {
          border: 'none',
        },
        '& input': {
          color: inputColor,
          fontSize: 14,
          textAlign: 'center',
          [theme.breakpoints.down('md')]: {
            fontSize: 12,
          },
          [theme.breakpoints.downLandscape('md')]: {
            ...(theme.isMobileDevice && {
              fontSize: 12,
            }),
          },
        },
      },
    };
  },
);
